import { createContext, useContext, type ReactNode } from 'react';

interface VisitorIdProviderProps {
  children: ReactNode;
  visitorId: string;
}

export const VisitorIdContext = createContext<string | null>(null);

export const VisitorIdProvider = ({
  children,
  visitorId,
}: VisitorIdProviderProps) => (
  <VisitorIdContext.Provider value={visitorId}>
    {children}
  </VisitorIdContext.Provider>
);

export const useVisitorId = (): string => {
  const context = useContext<string | null>(VisitorIdContext);
  if (context === null) {
    throw new Error('useVisitorId must be used within a VisitorIdProvider');
  }
  return context;
};
